import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import dayjs from 'dayjs';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { NewquanlytonkhoAction } from 'src/actions/newquanlytonkho.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getNewquanlytonkhoStatus } from 'src/utils/utils';
import ConfirmDialog from '../ConfirmDialog';
import {
  Button,
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
} from '@material-ui/core';
import ViewDetailDialog from './ViewDetailDialog';
import ViewDanhSachTon from './ViewDanhSachTon';

import numeral from 'numeral';

import { isGrantPermission } from 'src/utils/utils';

import CreateEditDialogNewdanhmucphieunhap from '../newdanhmucphieunhap-detail/CreateEditDialog';
import CreateEditDialogNewdanhmucphieuxuat from '../newdanhmucphieuxuat-detail/CreateEditDialog';

const NewquanlytonkhoLookupDetail = ({ ...rest }) => {
  const dispatch = useDispatch()
  const [selectedNewquanlytonkhoIds, setSelectedNewquanlytonkhoIds] = useState([]);
  const [limit, setLimit] = useState(DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(0);
  const { items, total, filter } = useSelector(state => state.newquanlytonkho);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [id_san_pham_chon, setIdSanPhamChon] = useState({});
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const [open_laydanhsachton, setOpen_laydanhsachton] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile)
  const [openNewdanhmucphieunhap, setOpenNewdanhmucphieunhap] = useState(false);
  const [openNewdanhmucphieuxuat, setOpenNewdanhmucphieuxuat] = useState(false);

  //==========

  const handleClickOpenNewdanhmucphieunhap = () => {
      setOpenNewdanhmucphieunhap(true);
  };

  const handleCloseNewdanhmucphieunhap = () => {
      setOpenNewdanhmucphieunhap(false);
  };

  //==========

  const handleClickOpenNewdanhmucphieuxuat = () => {
      setOpenNewdanhmucphieuxuat(true);
  };

  const handleCloseNewdanhmucphieuxuat = () => {
      setOpenNewdanhmucphieuxuat(false);
  };

  //==========
  
  useEffect(() => {
    const payload = {
      ...filter,
      limit: limit,
      page: page,
    };
    dispatch(NewquanlytonkhoAction.updateFilter(payload));
    dispatch(NewquanlytonkhoAction.list())
  }, [page, limit])

  const handleSelectAll = (event) => {
    let newSelectedNewquanlytonkhoIds;

    if (event.target.checked) {
      newSelectedNewquanlytonkhoIds = items.map((newquanlytonkho) => newquanlytonkho.id);
    } else {
      newSelectedNewquanlytonkhoIds = [];
    }

    setSelectedNewquanlytonkhoIds(newSelectedNewquanlytonkhoIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedNewquanlytonkhoIds.indexOf(id);
    let newSelectedNewquanlytonkhoIds = [];

    if (selectedIndex === -1) {
      newSelectedNewquanlytonkhoIds = newSelectedNewquanlytonkhoIds.concat(selectedNewquanlytonkhoIds, id);
    } else if (selectedIndex === 0) {
      newSelectedNewquanlytonkhoIds = newSelectedNewquanlytonkhoIds.concat(selectedNewquanlytonkhoIds.slice(1));
    } else if (selectedIndex === selectedNewquanlytonkhoIds.length - 1) {
      newSelectedNewquanlytonkhoIds = newSelectedNewquanlytonkhoIds.concat(selectedNewquanlytonkhoIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedNewquanlytonkhoIds = newSelectedNewquanlytonkhoIds.concat(
        selectedNewquanlytonkhoIds.slice(0, selectedIndex),
        selectedNewquanlytonkhoIds.slice(selectedIndex + 1)
      );
    }

    setSelectedNewquanlytonkhoIds(newSelectedNewquanlytonkhoIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleConfirmOpen = (type, newquanlytonkho) => {
    setSelected(newquanlytonkho);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(NewquanlytonkhoAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const viewDetail = (id) => {
    dispatch(NewquanlytonkhoAction.findOne(id, {
      startDate: filter.startDate || dayjs(moment().startOf('month').format('DD/MM/YYYY'), 'DD/MM/YYYY'),
      endDate: filter.endDate || dayjs(moment().endOf('month').format('DD/MM/YYYY'), 'DD/MM/YYYY'),
    }));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const layDanhSachTon = (id) => {
    dispatch(NewquanlytonkhoAction.layDanhSachTon(id, {
      startDate: filter.startDate || dayjs(moment().startOf('month').format('DD/MM/YYYY'), 'DD/MM/YYYY'),
      endDate: filter.endDate || dayjs(moment().endOf('month').format('DD/MM/YYYY'), 'DD/MM/YYYY'),
    }));
    setIdSanPhamChon({
      id,
      startDate: filter.startDate || dayjs(moment().startOf('month').format('DD/MM/YYYY'), 'DD/MM/YYYY'),
      endDate: filter.endDate || dayjs(moment().endOf('month').format('DD/MM/YYYY'), 'DD/MM/YYYY'),
    })
    setOpen_laydanhsachton(true);
  };

  const handleClose_laydanhsachton = () => {
    setOpen_laydanhsachton(false);
  };

  const setColor = (value) => {
    if (value == 'MOBIFONE') return 'green';
    else if (value == 'VINAPHONE') return 'blue';
    else if (value == 'VIETTEL') return 'red';
    else return 'black';
  };

  return (
    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: '500px', width: '100%' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Sản phẩm
                </TableCell>
                <TableCell className='text-center'>
                  Chi tiết
                </TableCell>
                <TableCell className='text-center'>
                  Tồn đầu kỳ
                </TableCell>
                <TableCell className='text-center' colSpan={2}>
                  Nhập trong kỳ
                </TableCell>
                <TableCell className='text-center' colSpan={2}>
                  Xuất trong kỳ
                </TableCell>
                <TableCell className='text-center' colSpan={2}>
                  Tồn cuối kỳ
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items && Object.values(items).length > 0 && items.slice(page * limit, page * limit + limit).map((newquanlytonkho, index) => (
                newquanlytonkho ? <TableRow
                  hover
                  key={newquanlytonkho.id}
                  selected={selectedNewquanlytonkhoIds.indexOf(newquanlytonkho.id) !== -1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      <span style={{fontWeight: 'bold'}}>{newquanlytonkho.ma} - {newquanlytonkho.ten}</span>
                      <br></br>
                      {typeof newquanlytonkho.newdanhmucnhacungcap_ref !== 'undefined' && newquanlytonkho.newdanhmucnhacungcap_ref ? (newquanlytonkho.newdanhmucnhacungcap_ref.ma + ' - ' + newquanlytonkho.newdanhmucnhacungcap_ref.ten) : ''}
                    </Typography>
                  </TableCell>
                  <TableCell className='text-center'>
                    <Button onClick={() => viewDetail(newquanlytonkho.id)} className="btn-view-custom-1 btn-buy-now bestSale-btn add-to-cart-v3s btn-sale">
                        <p>
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                              stroke="currentColor" width="18" height="18">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7
                                    -1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                          </svg>
                        </p>
                    </Button>
                  </TableCell>
                  <TableCell className='text-center'>
                    <span className='chi_so_ton_kho' style={{ fontWeight: 'bold', color: 'orange' }}>
                      {numeral(newquanlytonkho.ton_dau_ky).format('0,0[.]0')}
                    </span>
                  </TableCell>
                  <TableCell className='text-right'>
                    <span className='chi_so_ton_kho' style={{ fontWeight: 'bold', color: 'green' }}>
                      {numeral(newquanlytonkho.tong_nhap_ky).format('0,0[.]0')}
                    </span>
                  </TableCell>
                  <TableCell className='text-left'>
                    <Button onClick={() => handleClickOpenNewdanhmucphieunhap()} className="btn-view-custom-1 btn-import btn-buy-now bestSale-btn add-to-cart-v3s btn-sale">
                      <p>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          width="18"
                          height="18"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 4v16m8-8H4"
                          />
                        </svg>
                      </p>
                    </Button>
                  </TableCell>
                  <TableCell className='text-right'>
                    <span className='chi_so_ton_kho' style={{ fontWeight: 'bold', color: 'red' }}>
                      {numeral(newquanlytonkho.tong_xuat_ky).format('0,0[.]0')}
                    </span>
                  </TableCell>
                  <TableCell className='text-left'>
                    <Button onClick={() => handleClickOpenNewdanhmucphieuxuat()} className="btn-view-custom-1 btn-export btn-buy-now bestSale-btn add-to-cart-v3s btn-sale">
                      <p>
                        <svg 
                          xmlns="http://www.w3.org/2000/svg" 
                          fill="none" 
                          viewBox="0 0 24 24" 
                          stroke="currentColor" 
                          width="18" 
                          height="18"
                        >
                          <path 
                            stroke-linecap="round" 
                            stroke-linejoin="round" 
                            stroke-width="2" 
                            d="M20 12H4"
                          />
                        </svg>
                      </p>
                    </Button>
                  </TableCell>
                  <TableCell className='text-right'>
                    <span className='chi_so_ton_kho' style={{ fontWeight: 'bold', color: 'blue' }}>
                      {numeral(newquanlytonkho.ton_cuoi_ky).format('0,0[.]0')}
                    </span>
                  </TableCell>
                  <TableCell className='text-left'>
                    <Button onClick={() => layDanhSachTon(newquanlytonkho.id)} className="btn-view-custom-1 btn-layDanhSachTon btn-buy-now bestSale-btn add-to-cart-v3s btn-sale">
                        <p>
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                              stroke="currentColor" width="18" height="18">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7
                                    -1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                          </svg>
                        </p>
                    </Button>
                  </TableCell>
                </TableRow> : null
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
      <ViewDetailDialog open={open} handleClose={handleClose} type={"EDIT"} />
      <ViewDanhSachTon open={open_laydanhsachton} handleClose={handleClose_laydanhsachton} type={"EDIT"} id_san_pham_chon={id_san_pham_chon}/>
      <ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.so_dien_thoai_co_dau_cham} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
      <CreateEditDialogNewdanhmucphieunhap open={openNewdanhmucphieunhap} handleClose={handleCloseNewdanhmucphieunhap} type={"CREATE"} creatingFromAway={true} />
      <CreateEditDialogNewdanhmucphieuxuat open={openNewdanhmucphieuxuat} handleClose={handleCloseNewdanhmucphieuxuat} type={"CREATE"} creatingFromAway={true} />
    </Card>
  );
};

export default NewquanlytonkhoLookupDetail;
